import { develop } from "./develop";
import { local } from "./local";
import { production } from "./production";
import { stage } from "./stage";

const states = ["local", "develop", "stage", "master", "main"];
const state = process.env.STATE ?? states[0];

if (!states.includes(state))
  throw new Error(
    `STATE env can only be these values => ${states.join(", ")}, or you might not define it!`
  );

function getEnv() {
  if (state === "develop") return develop;
  if (state === "stage") return stage;
  if (state === "master" || state === "main") return production;
  return local;
}

export const env = getEnv();

export type * from "./types";
